import styled from "styled-components";

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    >button{ 
      height: 34px; 
        svg{ 
            transition: 200ms ease;
        } 
    } 
    
    &:hover{ 
        button{ 
            svg:hover { 
                transform: scale(1.5);
            } 
        } 
    }
`;

export default Container;
